/** Shipping carriers, their rate tables and destination zones (the `shipping` module). */
export default {
    index: {
        title: 'Shipping',
        intro: 'Carriers, rates & destination zones for {website}.',
        noWebsite: 'Select a website first to manage its shipping.',
    },
    tabs: {
        carriers: 'Carriers & rates',
        zones: 'Destination zones',
        sizes: 'Package sizes',
    },
    kinds: {
        ship: 'Ships to customer',
        pickup: 'Pickup / collect',
    },
    packageSizes: {
        intro: 'What each package size holds. A product gets the smallest size its dimensions fit, turned any way, within the weight; the rates are then matched on that size.',
        length: 'Max. length (mm)',
        width: 'Max. width (mm)',
        height: 'Max. height (mm)',
        weight: 'Max. weight (g)',
        default: 'standard limits, not saved yet',
        howItWorks: 'Leave a field empty for no limit. A product without dimensions has no size: rates of every size then apply and its weight picks the rate. A product too big for every size counts as a large parcel. Without a weight, the heaviest its size carries is used; with neither weight nor size, the dearest rate.',
        saved: 'Package sizes saved',
    },
    sizes: {
        any: 'Any size',
        letterbox: 'Letterbox',
        small: 'Small parcel',
        large: 'Large parcel',
    },
    shared: {
        enabled: 'Enabled',
        kind: 'Kind',
        sortOrder: 'Sort order',
    },
    carriers: {
        intro: 'Carriers customers pick from at checkout. Pickup skips the shipping address.',
        new: 'New carrier',
        empty: 'No carriers yet. Add a shipping carrier or a pickup option.',
        deliversTo: 'Delivers to',
        rates: 'no rates | {n} rate | {n} rates',
        noZones: 'No zones: this carrier is never offered',
        confirmDelete: 'Delete carrier "{name}"? Its rates are removed too.',
        created: 'Carrier created',
        saved: 'Carrier saved',
        deleted: 'Carrier deleted',
    },
    carrierEdit: {
        newTitle: 'New carrier',
        editTitle: 'Edit carrier',
        codeHint: 'Stable slug, frozen on orders.',
        kindLocked: 'Kind is fixed after creation.',
        pickupPrice: 'Pickup price (cents)',
        pickupPriceHint: 'Usually 0 for free collection.',
        pickupLocation: 'Pickup location / instructions',
        pickupLocationPlaceholder: 'Main St 1, open 9–5',
        rateTable: 'Rate table',
        rateTableHint: 'One row per zone × size × weight band; the cheapest matching row is quoted. The zone column is also where this carrier delivers: a zone with no row here is a zone it is never offered in. Several carriers may cover the same zone; the customer then picks one at checkout by name and price.',
        addRate: 'Add rate',
        zonesFirst: 'Create a destination zone first (Zones tab) before adding rates.',
        zone: 'Zone',
        service: 'Service',
        servicePlaceholder: 'Standard',
        size: 'Size',
        minWeight: 'Min g',
        maxWeight: 'Max g',
        price: 'Price (cents)',
        freeOver: 'Free over (cents)',
        daysMin: 'Days min',
        daysMax: 'Days max',
        sortOrderHint: 'Lower shows first in the checkout list.',
        create: 'Create carrier',
        save: 'Save carrier',
    },
    zones: {
        intro: 'Group destination countries into zones. A catch-all zone covers everything else.',
        new: 'New zone',
        empty: 'No zones yet. Add at least one to rate shipped carriers.',
        countries: 'Countries',
        restOfWorld: 'Rest of world',
        confirmDelete: 'Delete zone "{name}"? Rates referencing it are removed too.',
        created: 'Zone created',
        saved: 'Zone saved',
        deleted: 'Zone deleted',
    },
    zoneEdit: {
        newTitle: 'New zone',
        editTitle: 'Edit zone',
        namePlaceholder: 'Domestic / EU / World',
        countries: 'Country codes',
        countriesHint: 'ISO 3166-1 alpha-2, comma/space separated. Ignored for a catch-all zone.',
        postcodes: 'Postcodes (optional)',
        postcodesHint: 'One rule per line: a range (6300-6399), a prefix (62*), a number block (6291) or one exact code (6301 CV). Leave empty to cover the whole country. This is how a business that delivers itself sells only where its van goes.',
        catchAll: 'Rest-of-world catch-all',
        catchAllHint: 'Matches any destination no other zone claims.',
        create: 'Create zone',
        save: 'Save zone',
    },
};
